<template>
  <v-menu
    ref="menu1"
    v-model="dateMenuState"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="dateValue"
        label="Дата события"
        persistent-hint
        prepend-icon="event"
        readonly
        v-on="on"
      />
    </template>
    <v-date-picker
      v-model="dateValue"
      locale="ru"
      no-title
      :first-day-of-week="1"
      @input="onDateChanged"
    />
  </v-menu>
</template>

<script>
export default {
  name: 'date-picker',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      required: true,
      type: String,
    },
  },
  data: () => ({
    dateMenuState: false,
    dateValue: null,
  }),
  mounted() {
    this.dateValue = `${this.value}`;
  },
  methods: {
    onDateChanged(e) {
      this.$emit('change', e);
      this.dateMenuState = false;
      // this.$emit('onChanged', e);
    },
  },
};
</script>

<style scoped>

</style>
